export default "__VITE_ASSET__6367a300__"